import {
	AfterViewInit,
	Component,
	ViewChild
}												from '@angular/core'
import {
	BackendService,
	ConfigService,
  MapCoord,
  MapService,
	SearchResult,
	SearchService,
	StateService
}												from '../../'
import {
	FormBuilder,
	FormGroup,
	FormControl
}												from '@angular/forms'
import { SearchConfig }	from '../../'

declare var document: any

@Component({
  selector:			'electra-search',
  styleUrls:		[ './search.component.scss' ],
  templateUrl:	'./search.component.html'
})
export class SearchComponent implements AfterViewInit {
	config:			SearchConfig
	searchForm:	FormGroup
	state:			any
	textField:	any

  constructor(
    public backendService:  BackendService,
    public configService:   ConfigService,
    public formBuilder:     FormBuilder,
    public mapService:      MapService,
		private searchService:	SearchService,
    public stateService:    StateService
  ) {
		configService.search.subscribe(data => { this.gotConfig(data) });
		searchService.currentResult.subscribe(data => { this.gotCurrentResult(data) });
		stateService.app.subscribe(data => { this.gotState(data) });

		this.searchForm = formBuilder.group({
			address: [""]
		})

    console.log('Search component created');
	}

	ngAfterViewInit() {
		this.textField = document.getElementById('text-field');

    this.textField.addEventListener('focus', event => {
      this.searchService.focused.next(true);
    });

    this.textField.addEventListener('blur', event => {
      this.searchService.focused.next(false);
    });
	}

	clearClick() {
		this.searchService.currentResult.next(null);
		this.searchForm.controls['address'].setValue('')
		this.textField.focus()
	}

	gotConfig(config: SearchConfig) {
		this.config = config
	}

	gotCurrentResult(searchResult: SearchResult) {
		if (searchResult !== null) {
			this.searchForm.controls['address'].setValue(searchResult.address);
			this.textField.blur();
		}
	}
	
	gotState(data: any) {
		if (this.textField) {
			if (data.search) {
				this.textField.focus();
			} else {
				this.textField.blur();

				if (this.searchService.currentResult.value === null) {
					this.searchForm.controls['address'].setValue('');
				}
			}
		}
	}

	searchClick() {
		if (this.searchForm.value.address) {
			this.searchService.searchAddress(this.searchForm.value.address);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/search/search.component.ts